<div class="flex justify-content-end gap-2 pt-2 col-12">
    <ls-button-atom 
      [label]="labelCancel" 
      severity="secondary" 
      (onClick)="handleCancelClick($event)"/>
    <ls-button-icon-atom
      [label]="labelSave"
      icon="pi pi-save"
      type="submit"
      (onClick)="handleSaveClick($event)"
      [processing]="processing"></ls-button-icon-atom>
</div>
